import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  lang?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title = "Utvecklare Direkt - Ladda ner CV'n här",
  description = "Utvecklare Direkt kopplar samman svenska företag med skickliga ukrainska mjukvaruutvecklare för fjärrarbete.",
  keywords = "ukrainska utvecklare, svenska företag, fjärrarbete, mjukvaruutveckling, React, TypeScript",
  image = "https://www.utvecklaredirekt.se/og-image.png",
  url = "https://www.utvecklaredirekt.se",
  lang = "sv"
}) => {
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:locale" content={lang === 'sv' ? 'sv_SE' : 'en_US'} />

      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      <link rel="canonical" href={url} />
    </Helmet>
  );
};